import React, {useReducer} from 'react'

import LoginActions from '../../../../actions/LoginActions.js'
import reducer from '../../../../helpers/reducer.js'
import t from '../../../../helpers/Languages.js'

import {H3, H5, P, Alert, Button} from '../../../../components/UI/index.js'
import {FormStack, Toggle, Input, Select} from '../../../../components/UI/forms/index.js'
import {Customer} from '../../../../../server/functions/customers/customers.types.js'

interface SnelStartSettingsProps {
    user: Customer
    onChange: (user: Customer, save?: boolean) => void
}

interface SnelStartSettingsState {
    loading: boolean
    verified: boolean
    error: string
}

const initialState = {
    loading: false,
    verified: false,
    error: ''
}

export default function SnelStartSettings({user, onChange}: SnelStartSettingsProps) {
    const [{loading, verified, error}, dispatch] = useReducer<React.Reducer<SnelStartSettingsState, Partial<SnelStartSettingsState>>>(reducer, initialState)

    function onChangeChecked(key, event) {
        user.settings.webshops.snelstart[key] = event.target.checked

        onChange(user)
    }

    function onChangeValue(key, event) {
        user.settings.webshops.snelstart[key] = event.target.value

        onChange(user)
    }

    function onVerifyConnection() {
        dispatch({loading: true, verified: false, error: ''})

        onChange(user, true)

        setTimeout(() => { // wait for saving
            LoginActions.verifyWebshop('snelstart', (err) => {
                if (err) {
                    dispatch({loading: false, error: t('verificationFailed', err)})
                } else {
                    dispatch({loading: false, verified: true})
                }
            })
        }, 1000)
    }

    return (
        <div>
            <H3 style={{marginBottom: 36}}>SnelStart</H3>

            <H5 style={{marginBottom: 24}}>{t('settings')}</H5>

            <P style={{marginBottom: 24}}>{t('snelstartWebshopDescription')}</P>

            <FormStack>
                <Toggle
                    label={t('enabled')}
                    checked={user.settings.webshops.snelstart.active}
                    onChange={(event) => onChangeChecked('active', event)}
                />

                {user.settings.webshops.snelstart.active &&
                    <>
                        <Input
                            label={t('snelstartSubscriptionKey')}
                            info={t('snelstartSubscriptionKeyInfo')}
                            value={user.settings.webshops.snelstart.subscriptionKey}
                            onChange={(event) => onChangeValue('subscriptionKey', event)}
                        />

                        <Input
                            label={t('snelstartClientKey')}
                            info={t('snelstartClientKeyInfo')}
                            value={user.settings.webshops.snelstart.clientKey}
                            onChange={(event) => onChangeValue('clientKey', event)}
                        />

                        <Select
                            label={t('snelstartUpdateStatus')}
                            value={user.settings.webshops.snelstart.updateStatus}
                            onChange={(event) => onChangeValue('updateStatus', event)}
                        >
                            <option value=''>{t('never')}</option>
                            <option value='confirm'>{t('afterConfirm')}</option>
                            <option value='afterSent'>{t('afterSent')}</option>
                        </Select>

                        <Button
                            variant='text'
                            loading={loading}
                            onClick={onVerifyConnection}
                        >
                            {t('verify')}
                        </Button>

                        {error && (
                            <Alert style={{marginBottom: 6}} onClose={() => dispatch({error: ''})} variant='error'>{error}</Alert>
                        )}

                        {!error && verified && (
                            <Alert style={{marginBottom: 6}} onClose={() => dispatch({verified: false})}>{t('verificationSucceeded')}</Alert>
                        )}
                    </>
                }
            </FormStack>
        </div>
    )
}
